import styled from 'styled-components'

const lightGold = '#e3c791'
const darkGold = '#ba9657'

export const GoldenBg = styled.div `
    height: 100%;
    display: table-cell;
    display: block;
    background: ${lightGold}; /* For browsers that do not support gradients */
    background: -webkit-linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* For Safari 5.1 to 6.0 */
    background: -o-linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* For Opera 11.1 to 12.0 */
    background: -moz-linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* For Firefox 3.6 to 15 */
    background: linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* Standard syntax */
`

export const InfoBox = styled.div `
    @media (max-width: 1100px) {
        padding-left: 30px;
        padding-right: 30px;
        padding-top: ${props => props.paddingTop/3}px;
        padding-bottom: ${props => props.paddingBottom/3}px;
    }
    padding-left: ${props => props.paddingLeft}px;
    padding-right: ${props => props.paddingRight}px;
    padding-top: ${props => props.paddingTop}px;
    padding-bottom: ${props => props.paddingBottom}px;
`
InfoBox.defaultProps = {
    paddingTop: 40,
    paddingBottom: 70,
    paddingLeft: 90,
    paddingRight: 90,
}


export const Uppercase = styled.h1 `
    text-transform: uppercase;
    text-align: ${props => props.align};
    padding-top: ${props => props.paddingTop}px;
    padding-bottom: ${props => props.paddingBottom}px;
`
Uppercase.defaultProps = {
    paddingTop: 0,
    paddingBottom: 15,
    align: 'center'
}

export const Spacer = styled.div `
@media (max-width: 500px) {
    padding-top: 15px;
}
@media (max-width: 768px) {
    padding-top: 25px;
}
@media (min-width: 1024px) {
    padding-top: 35px;
}
  width:100%;
`


// WEBPACK FOOTER //
// /src/components/OnePager/OnePageStyle.js